import { Atom } from './Atom'
import { KeyOpts } from './KeyOpts'
import { Scope } from './Scope'

export type Key = [Scope, Atom] | [Scope, Atom, KeyOpts]
